var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22802_49523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79981 0.800003C6.32012 0.800003 5.5998 2.59688 5.5998 3.6375V5.6H9.59981V6H3.63731C2.31699 6 0.799805 7.04063 0.799805 10C0.799805 12.9594 2.31699 14 3.63731 14H5.9998V11.6C5.9998 10.7203 6.72012 10 7.59981 10H12.3998C13.0795 10 13.5998 9.47969 13.5998 8.8V3.6375C13.5998 2.2375 12.2795 0.800003 9.79981 0.800003ZM7.99981 2.8C8.44043 2.8 8.79981 3.15938 8.79981 3.6C8.79981 4.04063 8.44043 4.4 7.99981 4.4C7.55918 4.4 7.19981 4.04063 7.19981 3.6C7.19981 3.15938 7.55918 2.8 7.99981 2.8ZM13.9998 6V8.8C13.9998 9.67969 13.2795 10.4 12.3998 10.4H7.59981C6.92012 10.4 6.39981 10.9203 6.39981 11.6V16.3625C6.39981 17.7625 7.72012 19.2 10.1998 19.2C13.6795 19.2 14.3998 17.4031 14.3998 16.3625V14.4H10.3998V14H16.3623C17.6826 14 19.1998 12.9594 19.1998 10C19.1998 7.04063 17.6826 6 16.3623 6H13.9998ZM11.9998 15.6C12.4404 15.6 12.7998 15.9594 12.7998 16.4C12.7998 16.8406 12.4404 17.2 11.9998 17.2C11.5592 17.2 11.1998 16.8406 11.1998 16.4C11.1998 15.9594 11.5592 15.6 11.9998 15.6Z",
    fill: "#808191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22802_49523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.a26c726355b9aab0ece67b4a4f76bfcd.svg";
export { ForwardRef as ReactComponent };